import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty } from 'lodash';
import { Box, Fab, Grid, Tooltip, Typography } from '@mui/material';
import useTimeStore from '../ZustandProvider';
import OpenModalFromUrl from '../OpenModalFromUrl';

const PointMapComponent = ({ MapProps }) => {
  const coordOnMap = useTimeStore(state => state.coordOnMap);
  const [openModalViewLink, setOpenModalViewLink] = React.useState(false);
  const [isLoadingIpsilum, setIsLoadingIpsilum] = React.useState(false);
  const { server, source, streetViewType } = MapProps.map.settingsAdvancedMap.pointMap;
  const [linkSelected, setLinkSelected] = React.useState({});
  const defaultImage = 'https://sd1.d3.ipsilum.com/files_uploaded/lidar.png';
  const [viewLinkSelected, setViewLinkSelected] = React.useState('');
  const useStyles = makeStyles(() => ({
    fabWithPhoto: {
      position: 'relative',
      overflow: 'hidden',
      borderRadius: '50%',
      width: '56px',
      height: '56px'
    },
    photo: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }));
  const classes = useStyles();

  const getLinkLidarMap = async row => {
    const urlFunction = () => {
      let url;
      if (server.serverType === 'IGP') {
        url = `http://${server.ip}:${server.port}/MG/lidar/write_lidar_html`;
      } else if (server.serverType === 'IGPS' || server.serverType === 'input') {
        url = `${server.domain}/MG/lidar/write_lidar_html`;
      }
      return url;
    };
    setIsLoadingIpsilum(true);
    if (!isEmpty(coordOnMap)) {
      try {
        const response = await fetch(urlFunction(), {
          method: 'POST',
          body: JSON.stringify({
            disc: row.disc,
            ftpIp: '',
            ftpPort: '',
            ftpUser: '',
            ftpPassword: '',
            httpPort: '',
            projectsEntwine: [row.path],
            projectName: '',
            projectPath: 'htmls/lidar/tempwines',
            position: [coordOnMap.lat, coordOnMap.lng],
            user: ''
          }),
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'no-referrer'
        });

        const respuesta = await response.json();
        setViewLinkSelected(respuesta.htmlCreated);
        setOpenModalViewLink(true);
      } catch (error) {
        Bert.alert('No se encuentra mapa en estas coordenadas', 'error');
      } finally {
        setTimeout(() => {
          setIsLoadingIpsilum(false);
        }, 3000);
      }
    } else {
      Bert.alert('Selecciona un punto del mapa', 'warning');
    }
  };

  return (
    <>
      <Grid container direction="row" justifyContent="space-around" alignItems="stretch">
        <Typography variant="h5" gutterBottom>
          Select a point on the map
        </Typography>
      </Grid>
      {!isEmpty(coordOnMap) && (
        <>
          <Grid container direction="column">
            {((streetViewType && streetViewType === 'window') || !streetViewType) && (
              <Grid item justifyContent="space-around" alignItems="stretch" mb={2}>
                <Fab
                  color="primary"
                  aria-label="add"
                  onClick={() => {
                    window.open(
                      `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${coordOnMap.lat},${coordOnMap.lng}`,
                      '_blank'
                    );
                  }}
                  className={classes.fabWithPhoto}
                >
                  <img
                    alt="streetView"
                    src="https://srmconsulting.es/assets/img/soluciones/street.jpg"
                    className={classes.photo}
                  />
                </Fab>
              </Grid>
            )}
            {!isEmpty(source) && (
              <Grid item justifyContent="space-around" alignItems="stretch" mb={2}>
                {source.map(item => (
                  <Tooltip title={item.alias} placement="top-start" arrow key={item.name}>
                    <Fab
                      color="primary"
                      aria-label="add"
                      onClick={() => {
                        getLinkLidarMap(item);
                        setLinkSelected(item);
                      }}
                      className={classes.fabWithPhoto}
                    >
                      <img
                        alt="streetView"
                        src={item.image || defaultImage}
                        className={classes.photo}
                      />
                    </Fab>
                  </Tooltip>
                ))}
              </Grid>
            )}
          </Grid>
          {streetViewType && streetViewType === 'inside' && (
            <Grid item justifyContent="space-around" alignItems="stretch" mb={2}>
              <Box style={{ height: '500px' }}>
                <iframe
                  title="WebPage"
                  src={`https://www.google.com/maps/embed/v1/streetview?key=AIzaSyCgXcfztuA0NG4n_pXFYyEmdLZNWIdEHAo&location=${coordOnMap.lat},${coordOnMap.lng}&heading=210&pitch=10&fov=35`}
                  width="90%"
                  height="100%"
                  style={{ border: 0 }}
                />
              </Box>
            </Grid>
          )}
        </>
      )}

      <OpenModalFromUrl
        isFullScreen
        isLoading
        isLoadingIpsilum={isLoadingIpsilum}
        loadingTime={3000}
        openModal={openModalViewLink}
        setOpenModal={setOpenModalViewLink}
        title={
          !isEmpty(linkSelected.name)
            ? linkSelected.name.substring(0, linkSelected.name.lastIndexOf('.'))
            : ''
        }
        url={viewLinkSelected}
      />
    </>
  );
};

export default PointMapComponent;

PointMapComponent.defaultProps = {
  MapProps: {}
};
PointMapComponent.propTypes = {
  MapProps: PropTypes.object
};
